import auth from './reducers';

export default auth;
